// extracted by mini-css-extract-plugin
module.exports = {"container":"bag_container__goC1Y","firstSection":"bag_firstSection__KKBD3"};